import BaseModel from './BaseModel';
import { createDataExtractionField } from './DataExtractionField';

export const __typename = 'DataExtractionValueBaseDto';
export class DataExtractionValueBase extends BaseModel {
  constructor(data = {}) {
    super({ name: __typename }, data);
    this.id = data.id;
    this.field = data.field
      ? createDataExtractionField(data.field)
      : null;
  }
}
